/**
 * MoveProjectModal Messages
 *
 * This contains all the text for the MoveProjectModal component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.projects.duplicateCourseware';

export default defineMessages({
  modalTitle1: {
    id: `${scope}.modalTitle1`,
    defaultMessage: 'Select Workspace',
  },
  modalTitle2: {
    id: `${scope}.modalTitle2`,
    defaultMessage: 'Select Project',
  },
  searchTextPlaceholder: {
    id: `${scope}.searchTextPlaceholder`,
    defaultMessage: 'Search',
  },
  backButton: {
    id: `${scope}.backButton`,
    defaultMessage: 'Back',
  },
  duplicateButtonText: {
    id: `${scope}.duplicateButtonText`,
    defaultMessage: 'Duplicate',
  },
});
